import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ReactDOM from 'react-dom/client';
import './index.css';
import Router from "./Routes/Router";
import {ThemeProvider} from '@mui/material/styles';
import theme from './theme'; // Import your theme file
import store from './store'
import {Provider} from 'react-redux'


import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { isStorageSupported } from './utils/storageCheck';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,
            retry: 1,
            refetchOnWindowFocus: false,
        },
    },
});

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
const storageSupported = isStorageSupported();

const AppWrapper = ({ children }: { children: React.ReactNode }) => {
    if (storageSupported && clientId) {
        return (
            <GoogleOAuthProvider clientId={clientId}>
                {children}
            </GoogleOAuthProvider>
        );
    }
    return <>{children}</>;
};

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <AppWrapper>
                <Provider store={store}>
                    <ThemeProvider theme={theme}>
                        <Router/>
                    </ThemeProvider>
                </Provider>
            </AppWrapper>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    </React.StrictMode>
);
